"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cookie_1 = require("cookie");
var header_field_1 = require("header-field");
var mini_querystring_1 = require("mini-querystring");
var mini_url_1 = require("mini-url");
var Request = /** @class */ (function () {
    /**
     * @description
     * Wrapper around nodejs `IncomingMessage` that has pre parsed url
     * and other conveniences.
     *
     * @param ctx The related Rill Context for the request.
     * @param original The original IncomingMessage from rill/http.
     */
    function Request(ctx, original) {
        this.ctx = ctx;
        this.original = original;
        var conn = original.connection, headers = original.headers;
        var secure = conn.encrypted;
        var protocol = secure ? "https" : "http";
        this.path = original.url;
        this.method = original.method;
        this.origin = protocol + "://" + original.headers.host;
        this.headers = headers;
        this.secure = secure;
        /* istanbul ignore next */
        var parsed = process.browser
            ? original._options.parsed
            : mini_url_1.parse(original.url, this.origin);
        this.cookies = headers.cookie ? cookie_1.parse(headers.cookie) : {};
        /* istanbul ignore next */
        this.ip =
            conn.remoteAddress ||
                original.socket.remoteAddress ||
                (conn.socket && conn.socket.remoteAddress);
        // Attach url parts.
        for (var _i = 0, URL_PARTS_1 = mini_url_1.parts; _i < URL_PARTS_1.length; _i++) {
            var part = URL_PARTS_1[_i];
            this[part] = parsed[part];
        }
        this.matchPath = this.pathname;
        this.matchHost = this.hostname;
        this.subdomains = String(this.hostname)
            .split(".")
            .reverse()
            .slice(2);
        this.query = mini_querystring_1.parse(this.search, true);
        this.params = {};
    }
    /**
     * @description
     * Utility to retrieve a header from the request.
     *
     * @example
     * request.get('Host') // -> 'test.com'
     *
     * @param name The name of the request header to get.
     */
    Request.prototype.get = function (name) {
        return this.headers[header_field_1.normalize(name)];
    };
    return Request;
}());
exports.default = Request;
//# sourceMappingURL=request.js.map